<template>
  <div class="dynamic-field-container">
    <label>{{ field.label }}</label>
    <div class="el-input">
      <vue-numeric
        separator=","
        :data-vv-as="field.label"
        data-vv-validate-on="blur"
        :name="fieldName"
        class="twenty-five-percent el-input__inner"
        v-model="proxyValue"
        v-validate="fieldValidationRules"
        :disabled="isTaskFieldDisabled"
        :placeholder="field.placeholder"></vue-numeric>
      <small class="text-danger" v-show="errors.has(fieldName)" style="display:block; margin-top: 7px;">
        {{ getError(fieldName) }}
      </small>
    </div>
  </div>
</template>

<script>
  import {generateDynamicFieldValidation, canEditTaskField} from 'src/utilities/utils'
  import VueNumeric from 'vue-numeric'

  export default {
    inject: ['$validator'],
    props: ['field', 'value', 'commit', 'task', 'disabled'],
    fieldName: 'temp',
    components: { VueNumeric },
    computed: {
      fieldValidationRules () {
        // expressions override other validation logic
        if (this.field.expression) {
          this.fieldValidation = function(str) {
            return eval(str).apply(this)
          }.call(this, this.field.expression)
        }
        return this.fieldValidation
      },
      proxyValue: {
        get () {
          if (!this.value) {
            return 0
          }
          return this.value
        },
        set (newValue) {
          this.$store.commit(this.commit, { key: this.field.key, value: newValue })
        }
      },
      isTaskFieldDisabled () {
        if (this.disabled) {
          return true
        }
        return !canEditTaskField(this)
      }
    },
    data () {
      return {
        fieldValidation: {},
        statusOnLoad: null
      }
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      }
    },
    beforeMount () {
      generateDynamicFieldValidation(this)
      this.statusOnLoad = JSON.parse(JSON.stringify(this.task.status))
    }
  }
</script>

<style scoped>
  label {
    display: block;
  }
  .dynamic-field-container {
    margin-bottom: 10px;
  }
  .twenty-five-percent {
    width: 25%
  }
</style>
